import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Ourblogsheading from "./Ourblogsheading";
import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
// import axios from "axios";
import { api } from "../../api/client";
import BlogCard from "./BlogCard";
import { Box, Grid, Typography } from "@mui/material";
import "./Ourblogs.css";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import blogJson from "./Data/allBlogs.json";
import { Helmet } from "react-helmet-async";
import { Pagination } from "@mui/material";

function Ourblogs() {
  const [blogData, setBlogData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the window to the top when the component mounts
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await api.post("/blog/list", {
          status: "published",
          page: page,
          limit: 9,
        });

        const blogs = res.data.data.map((blog) => ({
          ...blog,
          bannerUrl: blog.thumbnail || null,
        }));

        setBlogData(blogs);

        setMeta(res.data.meta);
      } catch (err) {
        setError("Failed to load blogs");
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [page]);

  // async function fetchBlogs() {
  //   try {
  //     setLoading(true);
  //     setError(null);
  //     const response = await axios.get(
  //       "https://strapi.dwebbox.com/api/dwebboxes?populate=*&sort=createdAt:desc&pagination[limit]=1000"
  //     );
  //     console.log("API Response:", response);
  //     setBlogData(response.data.data);
  //   } catch (error) {
  //     console.error("Error fetching blogs:", error);
  //     setError("Failed to fetch blogs. Please try again later.");
  //   } finally {
  //     setLoading(false);
  //   }
  // }

  // useEffect(() => {
  //   fetchBlogs();
  // }, []);

  // useEffect(() => {
  //   console.log("blogData updated:", blogData);
  // }, [blogData]);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Our Blogs | Dwebbox - Insights on Tech & Design</title>
        <meta
          name="description"
          content="Explore the latest insights on web development, mobile app trends, and UI/UX design from the experts at Dwebbox. Stay updated with our news and tech blogs."
        />
        <link rel="canonical" href="https://dwebbox.com/blogs" />
      </Helmet>
      <ScrollToTopButton />
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <Navbar />
      <Ourblogsheading />
      <div className="blog-container">
        <Grid container spacing={3}>
          {blogData.length > 0 ? (
            blogData.map((blog) => (
              <Grid item xs={12} sm={6} md={4} lg={4} key={blog._id}>
                <BlogCard blog={blog} />
              </Grid>
            ))
          ) : (
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  minHeight: "400px",
                  textAlign: "center",
                  py: 8,
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: "#888",
                    fontWeight: 300,
                    mb: 2,
                  }}
                >
                  No blogs available
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#666",
                    fontSize: "16px",
                  }}
                >
                  Check back later for new content
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </div>
      {meta && meta.totalPages > 1 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 6,
            mb: 4,
          }}
        >
          <Pagination
            count={meta.totalPages}
            page={page}
            onChange={(event, value) => {
              setPage(value);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            color="primary"
            size="large"
            sx={{
              "& .MuiPaginationItem-root": {
                color: "#fff",
              },
            }}
          />
        </Box>
      )}

      <Bgimage />
      <Footer />
    </div>
  );
}

export default Ourblogs;
